"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var react_router_dom_1 = require("react-router-dom");
var format_price_1 = __importDefault(require("../../../../../utils/format-price"));
var classnames_1 = __importDefault(require("classnames"));
var remove_ships_every_text_1 = __importDefault(require("../../../../../utils/remove-ships-every-text"));
exports.default = (function (_a) {
    var order = _a.order;
    var renderAddress = function (address) { return (React.createElement("div", { className: 'margin-bottom-4' },
        React.createElement("div", null, address.address1),
        address.address2 && React.createElement("div", null, address.address2),
        React.createElement("div", null,
            address.city,
            ", ",
            address.province,
            " ",
            address.zip))); };
    var getTrackingURL = function (fulfillment) {
        switch (fulfillment.tracking_company) {
            case 'FEDEX':
                return "https://www.fedex.com/apps/fedextrack/?action=track&trackingnumber=".concat(fulfillment.tracking_number);
        }
    };
    return (React.createElement("div", { className: 'margin-bottom-8' },
        React.createElement("div", { className: 'bg-seashell padding-2 medium-padding-3' },
            React.createElement("span", { className: 'text-gray text-underline padding-right-4' },
                "#",
                order.id),
            " ",
            new Date(order.created_at).toDateString()),
        order.cancelled_at && (React.createElement("div", { className: 'bg-light-wisteria padding-left-2 text-black bordered' },
            React.createElement("span", { className: 'padding-right-4' }, "Cancelled on"),
            " ",
            new Date(order.cancelled_at).toDateString())),
        React.createElement("div", { className: 'bg-white' },
            React.createElement("div", { className: 'grid-x padding-6' },
                React.createElement("div", { className: 'cell medium-6 large-3' }, order.shipping_address && (React.createElement(React.Fragment, null,
                    React.createElement("div", { className: 'font-bold' }, "Deliver to"),
                    renderAddress(order.shipping_address)))),
                React.createElement("div", { className: 'cell medium-6 large-3' }, order.billing_address && (React.createElement(React.Fragment, null,
                    React.createElement("div", { className: 'font-bold' }, "Bill to"),
                    renderAddress(order.billing_address))))),
            React.createElement("hr", { className: 'border-seashell margin-0' }),
            React.createElement("div", { className: 'padding-horizontal-6 padding-vertical-4' },
                React.createElement("div", { className: 'table-scroll' },
                    React.createElement("table", { className: 'h7' },
                        React.createElement("thead", null,
                            React.createElement("tr", null,
                                React.createElement("th", { className: 'text-center' }, "Qty"),
                                React.createElement("th", null, "Item"),
                                React.createElement("th", { className: 'text-right' }, "Price"))),
                        React.createElement("tbody", null, order.line_items.map(function (lineItem) { return (React.createElement("tr", { key: lineItem.id },
                            React.createElement("td", { className: 'text-center' }, lineItem.quantity),
                            React.createElement("td", null, (0, remove_ships_every_text_1.default)(lineItem.name)),
                            React.createElement("td", { className: 'text-right' }, (0, format_price_1.default)(lineItem.price)))); }))))),
            React.createElement("hr", { className: 'border-seashell margin-0' }),
            React.createElement("div", { className: (0, classnames_1.default)('padding-6 text-right', { strike: !!order.cancelled_at }) },
                React.createElement("div", null,
                    React.createElement("small", null, "Product total"),
                    " ",
                    (0, format_price_1.default)(order.subtotal_price)),
                React.createElement("div", null,
                    React.createElement("small", null, "Tax"),
                    " ",
                    (0, format_price_1.default)(order.total_tax)),
                React.createElement("div", null,
                    React.createElement("small", null, "Shipping"),
                    " ",
                    (0, format_price_1.default)(order.shipping_lines.reduce(function (sum, l) { return sum + parseFloat(l.discounted_price); }, 0).toFixed(2))),
                React.createElement("div", null,
                    React.createElement("small", null, "Order total"),
                    " ",
                    (0, format_price_1.default)(order.total_price)),
                order.fulfillments.length > 0 && (React.createElement("div", null,
                    React.createElement("small", { className: 'padding-right-1' }, "Shipping"),
                    order.fulfillments.map(function (fulfillment) { return (React.createElement("small", { key: fulfillment.id },
                        React.createElement("a", { className: 'text-underline', href: getTrackingURL(fulfillment), target: '_blank' },
                            fulfillment.tracking_company,
                            " ",
                            fulfillment.tracking_number))); })))),
            order.is_cancellable && (React.createElement(react_router_dom_1.Link, { to: "/orders/cancel/".concat(order.id) },
                React.createElement("span", { className: 'text-wisteria text-underline padding-left-5 padding-bottom-10' }, "Cancel Order"))))));
});
